module.exports = __webpack_public_path__ + "img/logo-abcomm.938b1f22.png";